<footer [class.show-mobile]="screenSize <= SCREEN_SIZE.TABLET_LANDSCAPE_UP || shouldShowMobileVersion" [class.show-desktop]="screenSize > SCREEN_SIZE.TABLET_LANDSCAPE_UP && !shouldShowMobileVersion"
[class.commercial]="currentShownListingType === ListingCategory.COMMERCIAL" [class.luxury]="currentShownListingType === ListingCategory.LUXURY">
  <nav>
    <ul class="nav nav-tabs nav-justified is-flex-column">
      <!-- TODO: Do animations for sliding -->
      <li role="tab" tabindex="0" (keydown.enter)="toggleDropdown('canadaLocations')" (click)="toggleDropdown('canadaLocations')">
        <a translate="footer.canada-locations"></a>
        <i class="material-icons dropdown-caret has-pos-abs">{{ showCanadaLocations ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
        <div *ngIf="showCanadaLocations" class="dropdown-content" role="tabpanel">
          <ng-container *ngIf="currentShownListingType !== ListingCategory.COMMERCIAL">
            <ng-container *ngFor="let province of provinces">
              <a *ngIf="province !== 'qc'" [routerLink]="['/' + province]" translate="provinces.{{province}}"></a>
              <a *ngIf="province === 'qc'" (click)="openQuebecModal()" translate="provinces.{{province}}"></a>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="currentShownListingType === ListingCategory.COMMERCIAL">
            <a [routerLink]="['/']" translate="footer.residential-properties"></a>
            <a [routerLink]="['/commercial']" translate="footer.commercial-properties"></a>
          </ng-container>
        </div>
      </li>
      <li role="tab" tabindex="0" (keydown.enter)="toggleDropdown('siteSections')" (click)="toggleDropdown('siteSections')">
        <a translate="footer.site-sections"></a>
        <i class="material-icons dropdown-caret has-pos-abs">{{ showSiteSections ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
        <div *ngIf="showSiteSections" class="dropdown-content" role="tabpanel">
          <a href="/editorial/about-us/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.about-remax"></a>
          <a href="/editorial/why-remax/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.why-remax"></a>
          <a href="https://blog.remax.ca/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.blog"></a>
          <a [routerLink]="['/find-agent-or-office', 'agent']" translate="footer.find-remax-agent"></a>
          <a [routerLink]="['/find-agent-or-office', 'office']" translate="footer.find-remax-ofice"></a>
        </div>
      </li>
      <li role="tab" tabindex="0" (keydown.enter)="toggleDropdown('legal')" (click)="toggleDropdown('legal')">
        <a translate="footer.legal"></a>
        <i class="material-icons dropdown-caret has-pos-abs">{{ showLegal ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
        <div *ngIf="showLegal" class="dropdown-content" role="tabpanel">
          <a href="/editorial/copyright-terms-of-use/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.copyright-terms-of-use"></a>
          <a href="/editorial/privacy-policy/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.privacy-policy"></a>
          <a href="/editorial/phishing-and-scam-information/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.online-scams"></a>
          <a href="/editorial/legal/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.legal"></a>
        </div>
      </li>
      <li role="tab" tabindex="0" (keydown.enter)="toggleDropdown('corporate')" (click)="toggleDropdown('corporate')">
        <a translate="footer.corporate"></a>
        <i class="material-icons dropdown-caret has-pos-abs">{{ showCorporate ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
        <div *ngIf="showCorporate" class="dropdown-content" role="tabpanel">
          <div>
            <p><b>RE/MAX INTEGRA</b></p>
            <p>7101 Syntex Drive</p>
            <p>Mississauga, ON</p>
            <p>L5N 6H5</p>
            <p>Regional: 905-542-2400</p>
            <p>Fax: 905-542-3340</p>
            <a [routerLink]="['/find-agent-or-office','office']" translate="footer.find-nearest-office"></a>
          </div>
          <div>
            <p><b>RE/MAX of Western Canada</b></p>
            <p>#340 1060 Manhattan Drive</p>
            <p>Kelowna, BC</p>
            <p>V1Y 9X9</p>
            <p><b>Regional:</b> 250-860-3628</p>
            <a [routerLink]="['/find-agent-or-office','office']" translate="footer.find-nearest-office"></a>
          </div>
        </div>
      </li>
    </ul>
    <div class="is-flex has-flex-content-space-between content-wrapper">
      <section class="locations">
        <h4 translate="footer.canada-locations"></h4>
        <div class="content is-flex has-flex-wrap">
          <ng-container *ngIf="currentShownListingType !== ListingCategory.COMMERCIAL">
            <ng-container *ngFor="let province of provinces">
              <a *ngIf="province !== 'qc'" [routerLink]="['/' + province]" translate="provinces.{{province}}"></a>
              <a *ngIf="province === 'qc'" (click)="openQuebecModal()" translate="provinces.{{province}}"></a>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="currentShownListingType === ListingCategory.COMMERCIAL">
            <a [routerLink]="['/']" translate="footer.residential-properties"></a>
            <a [routerLink]="['/commercial']" translate="footer.commercial-properties"></a>
          </ng-container>
        </div>
      </section>
      <section class="site-sections">
        <h4 translate="footer.site-sections"></h4>
        <div class="content is-flex has-flex-wrap">
          <a href="/editorial/about-us/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.about-remax"></a>
          <a href="/editorial/why-remax/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.why-remax"></a>
          <a href="https://blog.remax.ca/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.blog"></a>
          <a [routerLink]="['/find-agent-or-office', 'agent']" translate="footer.find-remax-agent"></a>
          <a [routerLink]="['/find-agent-or-office', 'office']" translate="footer.find-remax-ofice"></a>
        </div>
      </section>
      <section class="legal">
        <h4 translate="footer.legal"></h4>
        <div class="content is-flex has-flex-wrap">
          <a href="/editorial/copyright-terms-of-use/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.copyright-terms-of-use"></a>
          <a href="/editorial/privacy-policy/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.privacy-policy"></a>
          <a href="/editorial/phishing-and-scam-information/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.online-scams"></a>
          <a href="/editorial/legal/" target="_blank" rel="noopener" (click)="$event.stopPropagation()" translate="footer.legal"></a>
        </div>
      </section>
      <section class="corporate">
        <h4 translate="footer.corporate"></h4>
        <div class="content is-flex has-flex-wrap">
          <div class="full-width is-flex">
            <div>
              <p><b>RE/MAX INTEGRA</b></p>
              <p>7101 Syntex Drive</p>
              <p>Mississauga, ON</p>
              <p>L5N 6H5</p>
              <p><b>Regional:</b> 905-542-2400</p>
              <p><b>Fax:</b> 905-542-3340</p>
              <a [routerLink]="['/find-agent-or-office','office']" translate="footer.find-nearest-office"></a>
            </div>
            <div>
              <p><b>RE/MAX of Western Canada</b></p>
              <p>#340 1060 Manhattan Drive</p>
              <p>Kelowna, BC</p>
              <p>V1Y 9X9</p>
              <p><b>Regional:</b> 250-860-3628</p>
              <a [routerLink]="['/find-agent-or-office','office']" translate="footer.find-nearest-office"></a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="connect is-flex has-flex-align-center">
      <p class="find-online"><b translate="footer.find-us-online"></b></p>
      <div>
        <hr/>
        <app-connect-social-bar twitter="REMAXca" facebook="https://www.facebook.com/REMAXno1/" pinterest="remaxca/?autologin=true"></app-connect-social-bar>
        <hr/>
      </div>
    </div>
  </nav>
  <section class="copyright-block text-center has-pos-rel">
    <div *ngIf="currentShownListingType === ListingCategory.LUXURY" class="scallop-logo has-pos-abs hide-on-tablet-up">
      <img src="{{'/assets/BalloonLarge.svg' | staticp }}" [alt]="'aria.logo' | translate" >
    </div>
    <p translate="footer.find-us-online" class="find-online"></p>
    <div class="logos">
      <hr/>
      <app-connect-social-bar twitter="REMAXca" facebook="https://www.facebook.com/REMAXno1/" pinterest="remaxca/?autologin=true"></app-connect-social-bar>
      <hr/>
    </div>
    <p class="copyright">{{ 'footer.copyright' | translate: {year: currentYear} }}</p>
    <p class="rights" translate="footer.rights-reserved"></p>
    <p class="associated-logos" translate="footer.trademarks"></p>
    <!-- <p translate="footer.disclaimer-vreb"></p> -->
  </section>
</footer>
